import React, { useEffect, useState } from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import GetUserActivityResponse from '../../../Api/CRM/Responses/UserActivityResponse';
import BooleanIcon from '../../elements/booleanIcon';
import Card from '../../elements/common/Card';
import Row, { TableDetailsBody } from '../../elements/common/TableDetailsRow';
import { IS_CASINO_ENABLED } from '../../helpers/Constants';

function UserActivity({ userId }: { userId: number }) {
    const [activity, setActivity] = useState<GetUserActivityResponse>({} as GetUserActivityResponse);

    useEffect(() => {
        if (userId > 0) {
            CRMApi.users.getActivity(userId).then(setActivity);
        }
    }, [userId]);

    return (
        <Card title="User activity">
            <TableDetailsBody>
                <Row label="Withdrawal cost sum">{activity.all_withdrawals_sum}</Row>
                <Row label="Single tickets sum">{activity.single_tickets_sum}</Row>
                <Row label="Multi tickets sum">{activity.multidraw_tickets_sum}</Row>
                <Row label="All tickets sum">{activity.all_tickets_sum}</Row>
                <Row label="All prize tickets sum">{activity.all_prize_tickets_sum}</Row>
                {IS_CASINO_ENABLED && (
                    <>
                        <Row label="Casino bets">{activity.allCasinoBets}</Row>
                        <Row label="Casino wins">{activity.allCasinoWins}</Row>
                        <Row label="Received casino bonus prizes ">{activity.allCasinoUserBonusesPrizes}</Row>
                    </>
                )}
                <Row label="Calculated balance">{activity.balance_calculated}</Row>
                <Row label="User balance">{activity.user_balance}</Row>
                <Row label="Balance difference">{activity.balance_difference}</Row>
                <Row label="Balance correct">
                    <BooleanIcon value={activity.balance_correct} />
                </Row>
            </TableDetailsBody>
        </Card>
    );
}

export default UserActivity;
